import { Grid } from '@material-ui/core';
import {
  createSelectField,
  createTextField,
  createNumberFormatField,
  createDateField,
  createCurrencyField,
} from '@roc/ui/componentBuilder';
import { observer } from 'mobx-react';
import { FileUploadDownloadArea } from '../common/fileUploadDownloadArea';
import { Document } from '@roc/feature-types';
import { UNDERWRITING } from '@roc/feature-utils';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import { useEffect } from 'react';
import { OTHER } from '../../../stores/documentForms/bankStatement/bankStatementFormStore';

interface BankStatementProps {
  loan: any;
  document: Document;
}

const BankStatement = observer((props: BankStatementProps) => {
  const { loan, document } = props;
  const disableDownload =
    !document?.dropboxPath || document?.dropboxPath.trim().length === 0;
  const { documentStore } = useDocumentStore();
  const { bankStatementFormStore } = documentStore.documentFormStore;

  useEffect(() => {
    const downloadExistingFile = !disableDownload
      ? document => documentStore.fetchDocumentFile(document)
      : null;
    bankStatementFormStore.fetchBankStatement(
      loan,
      document,
      downloadExistingFile
    );
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        {createDateField({
          store: bankStatementFormStore,
          testId: 'asOfDate',
          fieldName: 'asOfDate',
          label: 'As Of Date',
          disabled: true,
        })}
      </Grid>
      <Grid item xs={12} md={6}>
        {createSelectField({
          store: bankStatementFormStore,
          testId: 'accountHolder',
          fieldName: 'accountHolder',
          label: 'Account Holder',
          options: bankStatementFormStore.holderList,
          disabled: true,
        })}
      </Grid>
      <Grid item xs={12} md={6}>
        {createCurrencyField({
          label: 'Amount',
          fieldName: 'amount',
          testId: 'amount',
          store: bankStatementFormStore,
          disabled: true,
        })}
      </Grid>
      <Grid item xs={12} md={6}>
        {createTextField({
          store: bankStatementFormStore,
          testId: 'otherAccountHolderName',
          fieldName: 'otherAccountHolderName',
          label: 'Specify Other',
          disabled: true,
        })}
      </Grid>
      <Grid item xs={12} md={6}>
        {createNumberFormatField({
          store: bankStatementFormStore,
          testId: 'lastFourDigits',
          fieldName: 'lastFourDigits',
          label: 'Last 4 Of Account #',
          format: '####',
          disabled: true,
        })}
      </Grid>
    </Grid>
  );
});

export default BankStatement;
